import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { LangSwitch } from "./LangSwitch";
import { scrollToId } from "./SmoothScroll";
import { useI18n } from "@/lib/i18n";

export const Header = ({ overHero = false, showStays = false }) => {
  const { t } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 80);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const light = overHero && !scrolled;
  const links = [["amenities", "amenities"], ["location", "location"], ["reviews", "reviews"]];
  return (
    <header
      data-testid="main-navigation"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${light ? "bg-deep/30 backdrop-blur-sm border-b border-white/10" : "bg-paper/90 backdrop-blur-md border-b border-ink/10"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1280px] items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="brand-logo-link" aria-label="Samara Beach House"><Logo light={light} /></Link>
        <nav className="hidden items-center gap-8 md:flex">
          {showStays && <Link to="/stays" data-testid="nav-link-stays" className={`text-sm ${light ? "text-paper/90" : "text-ink/80"} hover:opacity-70`}>{t("nav.stays")}</Link>}
          {links.map(([id, k]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => scrollToId(id)} className={`text-sm transition-opacity hover:opacity-60 ${light ? "text-paper/90" : "text-ink/80"}`}>
              {t(`nav.${k}`)}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <LangSwitch light={light} />
          <button
            data-testid="nav-book-now-button"
            onClick={() => scrollToId("book")}
            className="hidden rounded-full bg-accent2 px-5 py-2.5 text-sm font-semibold text-[#1f160e] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-accent2/85 sm:block"
          >
            {t("nav.book")}
          </button>
        </div>
      </div>
    </header>
  );
};
